import { ArmyListUnit, Nullable } from '@Models';

export class ArmyListUnitView {
  id: string;
  item: ArmyListUnit;
  index: string;
  position: number;
  name: string;
  points: number;
  isEnabled: boolean;
  size: number;
  unitName: Nullable<string>;
  unit_id: number;
  organisationName: Nullable<string>;

  constructor(params: ArmyListUnitViewParams) {
    this.id = params.id;
    this.item = params.item;
    this.index = params.index;
    this.position = params.position;
    this.name = params.name;
    this.points = params.points;
    this.isEnabled = params.isEnabled;
    this.size = params.size;
    this.unitName = params.unitName ?? '';
    this.unit_id = params.unitId;
    this.organisationName = params.organisationName;
  }
}

export type ArmyListUnitViewParams = {
  id: string;
  item: ArmyListUnit;
  index: string;
  position: number;
  name: string;
  points: number;
  isEnabled: boolean;
  size: number;
  unitName: Nullable<string>;
  unitId: number;
  organisationName: Nullable<string>;
};
